<template>
  <component
    :is="componentName"
    v-bind="$attrs"
    v-on="$listeners"
    @hiden-view="hiddenView"
    @close="hiddenView" />
</template>

<script type="text/javascript">
import InvoiceCreate from '@/wkcrmViews/crm/invoice/Create'
import CustomerCreate from '@/wkcrmViews/crm/customer/Create'
import ContactsCreate from '@/wkcrmViews/crm/contacts/Create'
import LeadsCreate from '@/wkcrmViews/crm/leads/Create'
import BusinessCreate from '@/wkcrmViews/crm/business/Create'
import ContractCreate from '@/wkcrmViews/crm/contract/Create'
import ReceivablesCreate from '@/wkcrmViews/crm/receivables/Create'
import ReceivablesPlanCreate from '@/wkcrmViews/crm/receivablesPlan/Create'
import VisitCreate from '@/wkcrmViews/crm/visit/Create'
import ProductCreate from '@/wkcrmViews/crm/product/Create'
import MarketingCreate from '@/wkcrmViews/crm/marketing/components/Create'

export default {
  name: 'CRMAllCreate',
  components: {
    InvoiceCreate,
    CustomerCreate,
    ContactsCreate,
    BusinessCreate,
    ContractCreate,
    ReceivablesCreate,
    ReceivablesPlanCreate,
    VisitCreate,
    LeadsCreate,
    ProductCreate,
    MarketingCreate
  },
  inheritAttrs: false,
  props: {
    crmType: String
  },
  data() {
    return {
    }
  },
  computed: {
    componentName() {
      return {
        invoice: 'InvoiceCreate',
        customer: 'CustomerCreate',
        contacts: 'ContactsCreate',
        leads: 'LeadsCreate',
        business: 'BusinessCreate',
        contract: 'ContractCreate',
        receivables: 'ReceivablesCreate',
        visit: 'VisitCreate',
        product: 'ProductCreate',
        receivablesPlan: 'ReceivablesPlanCreate',
        marketing: 'MarketingCreate'
      }[this.crmType]
    }
  },
  watch: {

  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    hiddenView() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
